export default __webpack_public_path__ + "static/media/c2.dc53d4fc.png";